import { DynamicField, DynamicForm, FieldVariant, CustomFieldProps } from '@/components/form-builder/form-builder.types';
import { QuestionWithAnswer } from '../redacteur-dac-group.component';
import { RedacteurQuestionListComponent } from '../question-list/redacteur-question-list.component';

interface getRedacteurDacGroupFormObjectProps {
  questionsWithAnswer: QuestionWithAnswer[];
  onSelectionChange: (index: number, selected: boolean) => void;
  onAnswerChange: (index: number, answer: string) => void;
  onTypeChange: (index: number, type: 'SIMPLE' | 'ADDITIF') => void;
}

export const getRedacteurDacGroupFormObject = ({
  questionsWithAnswer,
  onSelectionChange,
  onAnswerChange,
  onTypeChange,
}: getRedacteurDacGroupFormObjectProps): DynamicForm => {
  // Custom component for question list
  const questionListField: DynamicField<CustomFieldProps> = {
    label: 'clarification.form.questions',
    variant: FieldVariant.CUSTOM,
    isRequired: false,
    props: {
      component: RedacteurQuestionListComponent,
      questions: questionsWithAnswer,
      onSelectionChange: onSelectionChange,
      onAnswerChange: onAnswerChange,
      onTypeChange: onTypeChange,
    },
  };

  return {
    title: 'clarification.answer_question',
    isHeaderHidden: true,
    grids: [
      {
        title: 'clarification.form.questions',
        isHeaderHidden: false,
        gridItems: [
          {
            fields: [questionListField],
          },
        ],
      },
    ],
  };
};
